(function () {
  const MOBILE_GAP = 12;
  const DESKTOP_GAP = 24;
  const DESKTOP_BREAKPOINT = 1024;
  const INTERACTIVE_SELECTOR =
    'button, a, input, select, textarea, label, modal-opener, product-form, quick-add-modal, .hindle-v2-product-card__atc, .swiper-no-swiping';

  let savedCarouselState = null;
  let modalOpen = false;

  function getCarouselGrid(carousel) {
    return carousel?.querySelector('.hindle-v2-products__grid');
  }

  function captureCarouselState(carousel) {
    const swiper = getCarouselGrid(carousel)?.swiperInstance;
    if (!swiper || swiper.destroyed) return null;

    return {
      carousel,
      index: swiper.activeIndex,
      translate: swiper.getTranslate(),
    };
  }

  function restoreCarouselState(state, animate) {
    if (!state?.carousel) return;

    const swiper = getCarouselGrid(state.carousel)?.swiperInstance;
    if (!swiper || swiper.destroyed) return;

    swiper.slideTo(state.index, animate ? 300 : 0, false);

    if (typeof state.translate === 'number') {
      window.requestAnimationFrame(() => {
        if (swiper.destroyed) return;
        if (swiper.getTranslate() === state.translate) return;
        swiper.setTransition(0);
        swiper.setTranslate(state.translate);
        swiper.updateProgress();
        swiper.updateSlidesClasses();
      });
    }
  }

  function syncCarouselNav(carousel, swiper) {
    if (!carousel.hasAttribute('data-hindle-v2-products-nav')) return;

    const prevBtn = carousel.querySelector('.hindle-v2-product-reviews__nav--prev');
    const nextBtn = carousel.querySelector('.hindle-v2-product-reviews__nav--next');
    const needsNav = !swiper.isLocked;

    carousel.classList.toggle('has-nav', needsNav);

    if (prevBtn) prevBtn.disabled = !needsNav || swiper.isBeginning;
    if (nextBtn) nextBtn.disabled = !needsNav || swiper.isEnd;
  }

  function bindCarouselInteractions(carousel, swiper) {
    if (carousel.dataset.hindleV2CarouselBound === 'true') return;
    carousel.dataset.hindleV2CarouselBound = 'true';

    carousel.addEventListener(
      'pointerdown',
      (event) => {
        if (!event.target.closest(INTERACTIVE_SELECTOR)) return;
        savedCarouselState = captureCarouselState(carousel);
      },
      true
    );

    carousel.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest(INTERACTIVE_SELECTOR)) return;
        savedCarouselState = captureCarouselState(carousel);
      },
      true
    );

    window.addEventListener('resize', () => {
      if (!modalOpen || !savedCarouselState) return;
      restoreCarouselState(savedCarouselState, false);
    });
  }

  function initCarousel(carousel) {
    if (!carousel || typeof Swiper === 'undefined') return;

    const grid = getCarouselGrid(carousel);
    const slides = grid?.querySelectorAll('.swiper-slide');
    if (!grid || !slides?.length) return;

    if (grid.swiperInstance && !grid.swiperInstance.destroyed) {
      bindCarouselInteractions(carousel, grid.swiperInstance);
      return;
    }

    if (grid.swiperInstance?.destroy) {
      grid.swiperInstance.destroy(true, true);
      grid.swiperInstance = null;
    }

    const hasNav = carousel.hasAttribute('data-hindle-v2-products-nav');
    const prevEl = hasNav ? carousel.querySelector('.hindle-v2-product-reviews__nav--prev') : null;
    const nextEl = hasNav ? carousel.querySelector('.hindle-v2-product-reviews__nav--next') : null;

    const config = {
      slidesPerView: 2,
      spaceBetween: MOBILE_GAP,
      watchOverflow: true,
      grabCursor: true,
      resistanceRatio: 0.85,
      slideToClickedSlide: false,
      preventClicks: true,
      preventClicksPropagation: true,
      a11y: false,
      noSwipingSelector: INTERACTIVE_SELECTOR,
      breakpoints: {
        640: {
          spaceBetween: DESKTOP_GAP,
        },
        [DESKTOP_BREAKPOINT]: {
          slidesPerView: 4,
          spaceBetween: DESKTOP_GAP,
        },
      },
    };

    if (prevEl && nextEl) {
      config.navigation = { prevEl, nextEl };
    }

    const swiper = new Swiper(grid, config);
    grid.swiperInstance = swiper;
    bindCarouselInteractions(carousel, swiper);

    if (hasNav) {
      const syncNav = () => syncCarouselNav(carousel, swiper);
      swiper.on('slideChange', syncNav);
      swiper.on('resize', syncNav);
      swiper.on('lock', syncNav);
      swiper.on('unlock', syncNav);
      syncNav();
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hindle-v2-products-carousel]').forEach(initCarousel);
  }

  function handleModalOpen() {
    modalOpen = true;
  }

  function handleModalClose() {
    modalOpen = false;
    if (!savedCarouselState) return;

    const state = savedCarouselState;
    savedCarouselState = null;

    window.requestAnimationFrame(() => {
      restoreCarouselState(state, false);
      window.requestAnimationFrame(() => {
        restoreCarouselState(state, false);
      });
    });
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(boot, 50);
      return;
    }
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(() => init(event.target), 50);
      return;
    }
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-hindle-v2-products-carousel]').forEach((carousel) => {
      const grid = getCarouselGrid(carousel);
      if (grid?.swiperInstance?.destroy) {
        grid.swiperInstance.destroy(true, true);
        grid.swiperInstance = null;
      }
      carousel.dataset.hindleV2CarouselBound = '';
    });
  });

  document.body.addEventListener('modalClosed', handleModalClose);
  document.addEventListener('quick-view-closed', handleModalClose);
  document.addEventListener('quick-view-open', handleModalOpen);
  document.addEventListener('quick-buy-action-complete', handleModalOpen);
})();
